import { render, staticRenderFns } from "./SubCategory.vue?vue&type=template&id=4d0467e6&scoped=true"
import script from "./SubCategory.vue?vue&type=script&lang=js"
export * from "./SubCategory.vue?vue&type=script&lang=js"
import style0 from "./SubCategory.vue?vue&type=style&index=0&id=4d0467e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0467e6",
  null
  
)

export default component.exports